import { render, staticRenderFns } from "./ps_expired_password_update_form.vue?vue&type=template&id=2dcc197a&"
import script from "./ps_expired_password_update_form.vue?vue&type=script&lang=js&"
export * from "./ps_expired_password_update_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports